import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
    handleDownloadMultipleFiles,
    handleDeleteFilePermanently,
    handleMarkAsDeleted,
    handleMarkAsActived,
    handleFileSubmissionSubmission,
    handleReprocessRepository,
    handleReprocessFile,
    handleSendSalesInformationEmail,
    handleAssociationEntityToPackage,
} from "./HandleUserActions";
import {
    pushModal,
    pushDialog,
    auditNoteSubmit,
    setDataFileStatusAction,
    saveWorkerAssociationPackageAction,
    deleteFilePermanentlyAction,
    deleteInvalidFilePermanentlyAction,
    hideFileAction,
    reprocessRepositoryAction,
    requestDataForOrganizationsAction,
    uploadAction,
    downloadAction,
    handleDownloadFilesAction,
    reprocessFileAction,
    sendSalesInformationEmail,
} from "../../store/actions";
import { connect } from "react-redux";
import { datetime } from "../../utils/datetime";
import { UserRoles } from "../../enums/userRoles";
import I18n from "../../I18n";
import { toast } from "react-toastify";
import { checkRolesByOrganizationProject, checkRoles } from "colbi_web_ui/lib/utils/roleValidator";
import defaultPackageAssociationStyles from "../../components/SeriesButton/SeriesButton.module.sass";

const UserActions = (props) => {
    const { params, checkList } = props;
    const [currentCheckedList, setCurrentCheckedList] = useState(undefined);
    const [originalCheckedList, setOriginalCheckedList] = useState(undefined);

    useEffect(() => {
        if (checkList?.length) {
            const checkedList = (checkList || []).filter((item) => item.checked);
            setCurrentCheckedList(JSON.stringify(checkedList));

            if (!originalCheckedList) {
                setOriginalCheckedList(JSON.stringify(checkedList));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkList]);

    useEffect(() => {
        setCurrentCheckedList(undefined);
        setOriginalCheckedList(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params?.entity, params?.filter]);

    if (params.section) {
        switch (params.section) {
            case "folders":
                return repositoryFoldersActions(props);
            case "invalid_files":
                return repositoryInvalidFiles(props);
            case "submission_saft":
                return fileSubmissionButton(props);
            case "merge_collisions":
                return mergeRepositoryMetadata(props);
            case "packages":
                const changesValidation = {
                    currentCheckedList,
                    originalCheckedList,
                    setCurrentCheckedList,
                    setOriginalCheckedList,
                };
                return packageAssociation(props, changesValidation);
            default:
                break;
        }
    }

    return null;
};

const mergeRepositoryMetadata = (props) => {
    const {
        styles,
        i18n,
        RegularButton,
        params,
        reprocessRepository,
        user,
        repositoryStatus,
        pushDialog,
    } = props;
    return (
        <div className={styles["actions-user-buttons"]}>
            <RegularButton
                primary
                icon="success"
                onClick={() => {
                    handleReprocessRepository({
                        pushDialog,
                        i18n,
                        params,
                        reprocessRepository,
                        user,
                        repositoryStatus,
                    });
                }}
                className={`${styles["simple-button"]}`}
            >
                {i18n`Merge Repo Metadata`}
            </RegularButton>
        </div>
    );
};

const repositoryInvalidFiles = (props) => {
    const { user, styles, i18n, RegularButton, checkbox, total, checkList, params } = props;
    const { projectId } = params || {};
    const validateUser = checkRolesByOrganizationProject(user, projectId, [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ]);
    const selectedFiles = (checkList || []).filter((x) => x.checked);
    return (
        <>
            {validateUser ? (
                <div className={styles["actions-user-buttons"]}>
                    {checkbox && total ? (
                        <div className={styles["actions-buttons"]}>
                            <RegularButton
                                danger
                                icon="success"
                                onClick={() => {
                                    if (selectedFiles && selectedFiles.length === 0) {
                                        toast.error(
                                            I18n.translate`Please Select Files to Delete!`,
                                            {
                                                position: "top-right",
                                                autoClose: 2000,
                                                hideProgressBar: true,
                                                closeOnClick: true,
                                                pauseOnHover: false,
                                                draggable: true,
                                                progress: undefined,
                                            },
                                        );
                                    } else {
                                        handleDeleteFilePermanently(props, toast);
                                    }
                                }}
                                className={`${styles["simple-button"]} ${styles["btn-delete-permanently"]}`}
                                data-toggle={"tooltip"}
                                data-placement={"top"}
                                title={i18n`This Action will delete the file from system`}
                            >
                                {i18n`Delete permanently`}
                            </RegularButton>
                        </div>
                    ) : null}
                </div>
            ) : (
                <div />
            )}
        </>
    );
};
const repositoryFoldersActions = (props) => {
    const { user, styles, i18n, RegularButton, checkbox, total, checkList, params, modules } =
        props;
    const { projectId } = params || {};
    const validateUser = [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.WRITER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ].includes(user.role);
    const validateUserRolesByProject = checkRolesByOrganizationProject(user, projectId, [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ]);
    const selectedFiles = (checkList || []).filter((x) => x.checked);
    const extraProps = {};
    const repoStatus = props.repositoryStatus.repoStatus;
    if (repoStatus === 2) {
        extraProps.disabled = true;
    }
    return (
        <>
            {validateUser ? (
                <div className={styles["actions-user-buttons"]}>
                    {checkbox && total ? (
                        <div className={styles["actions-repository"]}>
                            <RegularButton
                                icon="download-file"
                                onClick={() => {
                                    if (selectedFiles && selectedFiles.length === 0) {
                                        toast.error(
                                            I18n.translate`Please Select Files to Download!`,
                                            {
                                                position: "top-right",
                                                autoClose: 2000,
                                                hideProgressBar: true,
                                                closeOnClick: true,
                                                pauseOnHover: false,
                                                draggable: true,
                                                progress: undefined,
                                            },
                                        );
                                    } else {
                                        handleDownloadMultipleFiles(props);
                                    }
                                }}
                                className={`${styles["simple-button"]} ${styles["btn-download_files"]}`}
                                {...extraProps}
                            >
                                {i18n`Download file`}
                            </RegularButton>
                            {validateUserRolesByProject ? (
                                <div>
                                    <RegularButton
                                        danger
                                        icon="success"
                                        onClick={() => {
                                            if (selectedFiles && selectedFiles.length === 0) {
                                                toast.error(
                                                    I18n.translate`Please Select Files to Delete!`,
                                                    {
                                                        position: "top-right",
                                                        autoClose: 2000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                        pauseOnHover: false,
                                                        draggable: true,
                                                        progress: undefined,
                                                    },
                                                );
                                            } else {
                                                handleDeleteFilePermanently(props, toast);
                                            }
                                        }}
                                        className={`${styles["simple-button"]} ${styles["btn-delete-permanently"]}`}
                                        data-toggle={"tooltip"}
                                        data-placement={"top"}
                                        title={i18n`This Action will delete the file from the system and consequently making the data for this project inconsistent`}
                                        {...extraProps}
                                    >
                                        {i18n`Delete permanently`}
                                    </RegularButton>
                                    <RegularButton
                                        warning
                                        icon="success"
                                        onClick={() => {
                                            if (selectedFiles && selectedFiles.length === 0) {
                                                toast.error(
                                                    I18n.translate`Please Select Files to Inactivate!`,
                                                    {
                                                        position: "top-right",
                                                        autoClose: 2000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                        pauseOnHover: false,
                                                        draggable: true,
                                                        progress: undefined,
                                                    },
                                                );
                                            } else {
                                                handleMarkAsDeleted(props);
                                            }
                                        }}
                                        className={`${styles["simple-button"]} ${styles["btn-mark-delete"]}`}
                                        data-toggle={"tooltip"}
                                        data-placement={"top"}
                                        title={i18n`This action makes the file inactive but remains physically stored on the system. Consequently making the data for this project inconsistent`}
                                        {...extraProps}
                                    >
                                        {i18n`Inactivate file`}
                                    </RegularButton>
                                    <RegularButton
                                        primary
                                        icon="success"
                                        onClick={() => {
                                            if (selectedFiles && selectedFiles.length === 0) {
                                                toast.error(
                                                    I18n.translate`Please Select Files to Activate!`,
                                                    {
                                                        position: "top-right",
                                                        autoClose: 2000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                        pauseOnHover: false,
                                                        draggable: true,
                                                        progress: undefined,
                                                    },
                                                );
                                            } else {
                                                handleMarkAsActived(props);
                                            }
                                        }}
                                        className={`${styles["simple-button"]} ${styles["btn-mark-active"]}`}
                                        data-toggle={"tooltip"}
                                        data-placement={"top"}
                                        title={i18n`This action turns the inactive files into active. Makes the file data visible in views.`}
                                        {...extraProps}
                                    >
                                        {i18n`Activate file`}
                                    </RegularButton>
                                </div>
                            ) : null}
                            {!checkRoles(user, [UserRoles.READER]) &&
                            (modules || []).includes("submission_file") ? (
                                <RegularButton
                                    primary
                                    icon="success"
                                    onClick={() => {
                                        const validateFiles =
                                            checkList.filter(
                                                (x) =>
                                                    x.checked &&
                                                    (x.status !== "imported" ||
                                                        x.internalStatus === 1),
                                            ) || [];
                                        if (selectedFiles && selectedFiles.length === 0) {
                                            toast.error(
                                                I18n.translate`Please Select Files to Activate!`,
                                                {
                                                    position: "top-right",
                                                    autoClose: 2000,
                                                    hideProgressBar: true,
                                                    closeOnClick: true,
                                                    pauseOnHover: false,
                                                    draggable: true,
                                                    progress: undefined,
                                                },
                                            );
                                        } else if (validateFiles && validateFiles.length > 0) {
                                            toast.error(
                                                I18n.translate`Select files that have not yet been imported and submitted!`,
                                                {
                                                    position: "top-right",
                                                    autoClose: 2000,
                                                    hideProgressBar: true,
                                                    closeOnClick: true,
                                                    pauseOnHover: false,
                                                    draggable: true,
                                                    progress: undefined,
                                                },
                                            );
                                        } else {
                                            handleSendSalesInformationEmail(props);
                                        }
                                    }}
                                    className={`${styles["simple-button"]} ${styles["btn-mark-active"]}`}
                                    data-toggle={"tooltip"}
                                    data-placement={"top"}
                                    title={i18n`This action will validate the data and notify the organization owner.`}
                                    {...extraProps}
                                >
                                    {i18n`Submit File`}
                                </RegularButton>
                            ) : null}
                            {checkRoles(user, [
                                UserRoles.ADMIN,
                                UserRoles.SUPPORT,
                                UserRoles.PP_SUPPORT,
                            ]) ? (
                                <RegularButton
                                    icon="success"
                                    onClick={() => {
                                        if (selectedFiles && selectedFiles.length === 0) {
                                            toast.error(
                                                I18n.translate`Please Select Files to Reprocess!`,
                                                {
                                                    position: "top-right",
                                                    autoClose: 2000,
                                                    hideProgressBar: true,
                                                    closeOnClick: true,
                                                    pauseOnHover: false,
                                                    draggable: true,
                                                    progress: undefined,
                                                },
                                            );
                                        } else {
                                            handleReprocessFile(props);
                                        }
                                    }}
                                    className={`${styles["simple-button"]} ${styles["btn-download_files"]}`}
                                    {...extraProps}
                                >
                                    {i18n`Reprocess`}
                                </RegularButton>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            ) : (
                <div />
            )}
        </>
    );
};

const packageAssociation = (props, changeValidation) => {
    const { styles, i18n, RegularButton } = props;
    const stylesSelected = { ...defaultPackageAssociationStyles, ...styles };
    const {
        currentCheckedList,
        originalCheckedList,
        setCurrentCheckedList,
        setOriginalCheckedList,
    } = changeValidation;
    const enableSaveButton =
        currentCheckedList && originalCheckedList && currentCheckedList !== originalCheckedList;

    return (
        <div className={stylesSelected["container"]}>
            <RegularButton
                primary
                icon="success"
                onClick={() => {
                    handleAssociationEntityToPackage({
                        ...props,
                        setCurrentCheckedList,
                        setOriginalCheckedList,
                    });
                }}
                className={`${stylesSelected["simple-button"]}`}
                disabled={!enableSaveButton}
            >
                {i18n`save changes`}
            </RegularButton>
        </div>
    );
};

const fileSubmissionButton = (props) => {
    const { styles, i18n, RegularButton, reload } = props;
    return (
        <div className={styles["actions-buttons"]}>
            <div>
                <RegularButton
                    icon="refresh"
                    onClick={() => reload && reload()}
                    iconClassName={`${styles["small-background-color"]}`}
                    className={`${styles["simple-button"]} ${styles["btn-refresh"]} ${styles["btn-background-color"]}`}
                />
                <small className={`${styles["btn-refresh"]} ${styles["small-background-color"]}`}>
                    {i18n`Last update:`} {datetime(new Date())}
                </small>
            </div>
            <RegularButton
                primary
                icon="success"
                onClick={() => {
                    const selectedFiles = props.checkList.filter((x) => x.checked);
                    if (selectedFiles && selectedFiles.length === 0) {
                        toast.error(I18n.translate`Please Select Files to Submit!`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    } else {
                        handleFileSubmissionSubmission(props);
                    }
                }}
                className={`${styles["simple-button"]}`}
            >
                {i18n`SAF-T Submission`}
            </RegularButton>
        </div>
    );
};

export default connect(
    ({ fetch, menu, uploads }) => ({
        fetch,
        menu,
        uploads,
    }),
    {
        pushModal,
        pushDialog,
        setDataFileStatus: setDataFileStatusAction,
        saveWorkerAssociationPackage: saveWorkerAssociationPackageAction,
        deleteFilePermanently: deleteFilePermanentlyAction,
        deleteInvalidFilePermanently: deleteInvalidFilePermanentlyAction,
        hideFile: hideFileAction,
        downloadFiles: handleDownloadFilesAction,
        reprocessRepository: reprocessRepositoryAction,
        requestDataForOrganizations: requestDataForOrganizationsAction,
        uploadFiles: uploadAction,
        download: downloadAction,
        submitAuditNote: auditNoteSubmit,
        reprocessFiles: reprocessFileAction,
        sendSalesInformationEmail,
    },
)(withRouter(UserActions));
